import { render, staticRenderFns } from "./ipWhitelistingEdit.vue?vue&type=template&id=4cf1bce2&"
import script from "./ipWhitelistingEdit.vue?vue&type=script&lang=js&"
export * from "./ipWhitelistingEdit.vue?vue&type=script&lang=js&"
import style0 from "./ipWhitelistingEdit.vue?vue&type=style&index=0&id=4cf1bce2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports